import React from "react";

const Loading = ({ size = 30, color = "#6720A4", removeBG = false }) => {
  const spinnerStyle = {
    border: "4px solid #f3f3f3",
    borderTop: `4px solid ${color}`,
    borderRadius: "50%",
    width: `${size}px`,
    height: `${size}px`,
    animation: "spin 1s linear infinite",
    margin: "auto",
  };

  const wrapperStyle = removeBG
    ? {}
    : {
        height: "100vh",
        backgroundColor: "#fff",
      };

  return (
    <React.Fragment>
      <div className="d-flex justify-content-center w-100" style={wrapperStyle}>
        <div style={spinnerStyle}></div>
      </div>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
    </React.Fragment>
  );
};

export default Loading;
